import Model from 'flarum/common/Model';
export default class DiscussionTranslation extends Model {
  language() {
    return Model.attribute('language').call(this);
  }
  title() {
    return Model.attribute('title').call(this);
  }
  provider() {
    return Model.attribute('provider').call(this);
  }
  sourceLanguage() {
    return Model.attribute('sourceLanguage').call(this);
  }
  updatedAt() {
    return Model.attribute('updatedAt', Model.transformDate).call(this);
  }
}
flarum.reg.add('fof-translate', 'common/models/DiscussionTranslation', DiscussionTranslation);